/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateEmailVorlageDto } from '../../models/lexplus-create-email-vorlage-dto';
import { LexplusEmailVorlageDetailDto } from '../../models/lexplus-email-vorlage-detail-dto';

export interface EmailTemplateControllerCreateV1$Params {
      body: LexplusCreateEmailVorlageDto
}

export function emailTemplateControllerCreateV1(http: HttpClient, rootUrl: string, params: EmailTemplateControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailVorlageDetailDto>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailVorlageDetailDto>;
    })
  );
}

emailTemplateControllerCreateV1.PATH = '/v1/email-templates';
